import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './style.css';

const STEPS = ['cart', 'address', 'payment'];
const STEP_PATHS = {
  cart: '/checkout/cart',
  address: '/checkout/address',
  payment: '/checkout/payment',
};

export default function OrderSteps({ currentStep, onStepClick }) {
  const navigate = useNavigate();

  const currentStepIndex = STEPS.indexOf(currentStep);

  // Only allow backward navigation (clicking on previous steps)
  const handleStepClick = step => {
    const clickedStepIndex = STEPS.indexOf(step);

    // Only allow clicking on previous steps (backward navigation)
    // Forward navigation is disabled - use checkout button instead
    if (clickedStepIndex < currentStepIndex) {
      if (onStepClick) {
        onStepClick(step);
      } else {
        navigate(STEP_PATHS[step]);
      }
    }
  };

  const getStepClassName = step => {
    const stepIndex = STEPS.indexOf(step);
    const isActive = step === currentStep;
    const isCompleted = stepIndex < currentStepIndex;
    const isClickable = stepIndex < currentStepIndex;

    let className = 'order-step';
    if (isActive) className += ' order-step-active';
    if (isCompleted) className += ' order-step-completed';
    if (isClickable) className += ' order-step-clickable';

    return className;
  };

  const getLineClassName = afterStep => {
    const stepIndex = STEPS.indexOf(afterStep);
    const isCompleted = stepIndex < currentStepIndex;
    return `order-step-line ${isCompleted ? 'order-step-line-completed' : ''}`;
  };

  return (
    <div className="order-steps-container">
      <div className="order-steps">
        <div className={getStepClassName('cart')} onClick={() => handleStepClick('cart')}>
          <span className="order-step-number">1</span>
          <span className="order-step-label">Bag</span>
        </div>
        <div className={getLineClassName('cart')}></div>
        <div className={getStepClassName('address')} onClick={() => handleStepClick('address')}>
          <span className="order-step-number">2</span>
          <span className="order-step-label">Address</span>
        </div>
        <div className={getLineClassName('address')}></div>
        <div className={getStepClassName('payment')} onClick={() => handleStepClick('payment')}>
          <span className="order-step-number">3</span>
          <span className="order-step-label">Payment</span>
        </div>
      </div>
    </div>
  );
}
